import { takeLatest, call, select, put } from 'redux-saga/effects'
import {
    CANCEL_MEMBER_SHIP,
    GET_PACKAGE,
    GET_SUB_SCRIPTION,
    SET_USER_PROFILE,
    SET_CANCEL_MEMBER_SHIP,
    GET_USER_PROFILE,
    SET_CONTEXT,
    DESTROY_CONTEXT,
    ADD_PACKAGE_LISTS
} from '../actions/type'
import { showSpinner, hideSpinner } from '../actions/actions'
import {
    genVRoomToken,
    getHttpClient,
    getSelector,
    destroyUserInfo,
    setHttpErrObj,
    setCookie,
    getHttpVtoken,
    setContextInfo,
    getContextInfo
} from '../../helpers'
import { head, isEmpty } from 'lodash';


const keycloakSelector = getSelector('keycloak')

function getHttpCancelMemberShip(keycloak, url, headers = {}) {
    return fetch(url, {
        method: 'GET',
        headers,
    }).then((response) => {
        if (response.status === 401) {
            destroyUserInfo()
            keycloak.logout()
        } else if (response.status >= 500) {
            const errorObj = setHttpErrObj("getHttpCancelMemberShip", "status bad request", "HTTP Client GET: status bad request " + response.url)
            setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
            window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
        } else {
            return response.json().then(data => ({ status: response.status, data }))
        }

    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client GET', err))
}

function* getSubScription() {
    const keycloak = yield select(keycloakSelector)
    const url = `${window._env_.subscriberServiceBaseURL}/v1/subscriptionStatus`
    if (!isEmpty(keycloak)) {
        yield put(showSpinner)
        try {
            const token = yield call(genVRoomToken, keycloak)
            const response = yield call(getHttpClient, keycloak, url, { Authorization: "Bearer " + token })
            if (!isEmpty(response.data)) {
                const { data: { nextCycleDate, recurringStatus, expireDate } } = response
                yield put({
                    type: SET_USER_PROFILE,
                    payload: {
                        nextCycleDate,
                        recurringStatus,
                        expireDate,
                    }
                })
            } else {
                yield put({
                    type: SET_USER_PROFILE,
                    payload: {
                        nextCycleDate: '',
                        recurringStatus: '',
                        expireDate: '',
                    }
                })
            }
        } catch (error) {
            console.error('getSubScription', error)
        }
        yield put(hideSpinner)
    }
}


function* getPackage() {
    const keycloak = yield select(keycloakSelector)
    const url = `${window._env_.subscriberServiceBaseURL}/v1/packages`
    if (!isEmpty(keycloak)) {
        yield put(showSpinner)
        try {
            const token = yield call(genVRoomToken, keycloak)
            const response = yield call(getHttpClient, keycloak, `${url}?jwt=${token}`)
            if (!isEmpty(response.packages)) {
                const findCurrent = response.packages.filter(packages => packages.showPackageState === "current")
                // const findCurrent= [];
                // findCurrent[0] = response.packages[2]
                if (findCurrent.length > 0) {
                    yield put({
                        type: SET_USER_PROFILE,
                        payload: {
                            currentPackage: head(findCurrent),
                            packageType: head(findCurrent).packageType
                        }
                    })

                    yield put({
                        type: ADD_PACKAGE_LISTS,
                        payload: {
                            packages: response.packages
                        }
                    })
                }
            }
        } catch (error) {
            console.error('getPackage', error)
        }
        yield put(hideSpinner)
    }
}


function* cancelMemberShip() {
    const keycloak = yield select(keycloakSelector)
    if (!isEmpty(keycloak)) {
        yield put(showSpinner)
        try {

            const token = yield call(genVRoomToken, keycloak)
            const url = `${window._env_.subscriberServiceBaseURL}/v1/cancelSubscription`
            const response = yield call(getHttpCancelMemberShip, keycloak, url, {
                Authorization: "Bearer " + token
            })

            if (!isEmpty(response.data)) {
                console.log('response', response)
                yield put({
                    type: SET_CANCEL_MEMBER_SHIP,
                    payload: {
                        data: response.data,
                        status: response.status
                    }
                })

            }


        } catch (err) {
            console.log('cancelMemberShip', err)
        }
        yield put(hideSpinner)
    }

}


function* getUserProfile() {
    const keycloak = yield select(keycloakSelector)
    const url = `${window._env_.subscriberServiceBaseURL}/v1/user`
    if (!isEmpty(keycloak)) {
        yield put(showSpinner)
        try {
            const token = yield call(genVRoomToken, keycloak)
            const response = yield call(getHttpClient, keycloak, url, {
                Authorization: "Bearer " + token
            })

            const { displayname, avatar } = response
            yield put({
                type: SET_USER_PROFILE,
                payload: {
                    displayname,
                    avatar: !isEmpty(avatar) ? avatar : ''
                }
            })
        } catch (error) {
            console.error('getUserProfile', error)
        }
        yield put(hideSpinner)
    }
}


function* destroyContext() {
    try {
        const keycloak = yield select(keycloakSelector)
        const url = window._env_.subscriberServiceBaseURL + "/v1/token"
        const headers = {
            Authorization: "Bearer " + keycloak.idToken
        }
        const response = yield call(getHttpVtoken, keycloak, url, headers)
        const { token } = response
        yield call(setContextInfo, token)
        localStorage.setItem('vtoken', token)
        let context = yield call(getContextInfo, keycloak)
        let { avatar, email, name, p, pkgcode } = context
        yield put({
            type: SET_CONTEXT,
            payload: {
                avatar, email, name, p, pkgcode
            }
        })
    } catch (error) {

    }
}

function* userProfileHistorySaga() {
    yield takeLatest(GET_SUB_SCRIPTION, getSubScription)
    yield takeLatest(CANCEL_MEMBER_SHIP, cancelMemberShip)
    yield takeLatest(GET_PACKAGE, getPackage)
    yield takeLatest(GET_USER_PROFILE, getUserProfile)
    yield takeLatest(DESTROY_CONTEXT, destroyContext)
}

export default userProfileHistorySaga
